import { createContext } from 'react';
import { GalleryContextType } from '#advertDetail/components/gallery';

const GalleryContext = createContext<GalleryContextType>(null);

export { GalleryContext };
